'use client';

import type { CSSProperties, ReactElement } from 'react';
import { Cbutton } from '../Cbutton/Cbutton';
import { ButtonPreset } from '@/constants/componentPresets';
import { dataEl, type DataElScope } from '@/utils/dataEl';

interface MessageModalSecondaryButtonProps {
    dataElScope: DataElScope;
  label?: string;
  loading: boolean;
  padding?: string;
  height?: number;
  style: CSSProperties;
  onClick: () => void;
}

export function MessageModalSecondaryButton({
  dataElScope,
  label,
  loading,
  padding,
  height,
  style,
  onClick,
}: MessageModalSecondaryButtonProps): ReactElement | null {
  if (!label) {
    return null;
  }

  return (
    <Cbutton
      rootAttributes={{ "data-el": dataEl(dataElScope, 'SecondaryButton/Root') }}
      preset={ButtonPreset.Secondary}
      label={label}
      onClick={onClick}
      disabled={loading}
      padding={padding}
      height={height}
      style={style}
    />
  );
}
